<template>
    <diagram :data="displayedTouchPoints" :types="sankeyTypes"/>
</template>

<script>
    import sankeyMixin from '../../Mixins/sankey-diagram';

    export default {
        name: 'journey-sankey-diagram-simple',
        mixins: [sankeyMixin],
        computed: {
            displayedTouchPoints(){
                const vm = this;
                return vm.sankeyData.map(d => vm.mapToDisplayedTouchPoint(d));
            }
        }
    };
</script>